import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Select, DatePicker, Cascader } from 'antd';
import { Layer } from '../../constants/dimension';
import SearchRetrieve from '../../../common/SearchRetrieve.new';
import API_URL from '../../../../common/url';
import format from '../../../shared/format';
import moment from 'moment';
import { generateOptions } from '../../../shared/selectFn';
import { DisplayType } from '../../constants/common';

const { Option } = Select;
const monthFormat = 'YYYY-MM';
const { MonthPicker } = DatePicker;
const displayTypeOption = generateOptions(DisplayType);
const LayerOption = Object.keys(Layer).map(i => <Option key={i}>{ Layer[i] }</Option>);

const MedicineTypeList = [
    {value: 'Research_drugs', label: '药物'},
    {
        value: 'Technology', 
        label: '技术类',
        children: [
            {
                value: 'Radiation_therapy', 
                label: '放射疗法（同位素 核药；照射）',
            },
            {
                value: 'Cell_therapy', 
                label: '细胞治疗: CART',
            },
            {
                value: 'Stem_cell_therapy', 
                label: '干细胞治疗',
            },
            {
                value: 'Organ_transplant', 
                label: '器官移植',
            },
            {
                value: 'Gene_therapy', 
                label: '基因治疗',
            },
            {
                value: 'Dialysis', 
                label: '透析',
            },
        ]
    },
    {value: 'Medical_instruments', label: '医疗器械'},
    {value: 'Vaccines', label: '疫苗'},
    {value: 'Diagnostic_reagent', label: '诊断试剂'},
    {value: 'Others', label: '其他'},
]

class ChartFilter extends Component {
    static defaultProps = {
        isPieChart: false
    }

    static contextTypes = {
        business: PropTypes.array,
        systemDate: PropTypes.object
    }

    handleChange = (value, key) => {
        const { params, onChange } = this.props;
        switch (key) {
            case 'leaderUser': {
                const { value: id, text: name } = value;
                params[`${key}Id`] = id;
                params[`${key}Name`] = name;
                break;
            }
            default:
                params[key] = value;
                break;
        }
        onChange(params);
    }

    disabledDate = (current) => {
        const { systemDate: { date } = {} } = this.context;
        const value = moment(format('month', date)).add(1, 'M').valueOf();
        return current && current.valueOf() >= value;
    }

    render() {
        const { business, systemDate: { trueYear } } = this.context;
        const { params, onSearch, onExport, isPieChart } = this.props;
        const businessOption = business
            .filter(i => i.groupId !== 2)
            .map(i => <Option key={i.typeConfigureId}>{i.typeValue}</Option>);
        const statisticsDateOption = [];
        for (let start = 2016, end = trueYear || 2016; start <= end; start++) {
            statisticsDateOption.push(<Option key={start}>{start}</Option>);
        }
        const medicineTypeOptions = MedicineTypeList.map(d => <Option key={String(d.value)} title={d.label}>{d.label}</Option>);
        return (
            <div className="filter-wrap" style={{ marginBottom: 10, padding: 10, background: '#fff' }}>
                <div className="filter-item">
                    <label htmlFor="" className="filter-label">业务线</label>
                    <Select
                        allowClear={true}
                        placeholder="请选择"
                        value={format('toString', params.lineOfBusiness)}
                        style={{ width: 100, verticalAlign: 'middle' }}
                        onChange={value => this.handleChange(value, 'lineOfBusiness')}
                    >
                        {businessOption}
                    </Select>
                </div>
                {
                    !isPieChart &&
                    <div className="filter-item">
                        <label htmlFor="" className="filter-label">统计形式</label>
                        <Select
                            placeholder="请选择"
                            value={format('toString', params.displayType)}
                            style={{ width: 140, verticalAlign: 'middle' }}
                            onChange={value => this.handleChange(value, 'displayType')}
                        >
                            {displayTypeOption}
                        </Select>
                    </div>
                }
                <div className="filter-item">
                    <label htmlFor="" className="filter-label">分析层面</label>
                    <Select
                        allowClear={true}
                        placeholder="请选择"
                        value={format('toString', params.statisticalRange)}
                        style={{ width: 100, verticalAlign: 'middle' }}
                        onChange={value => this.handleChange(value, 'statisticalRange')}
                    >
                        {LayerOption}
                    </Select>
                </div>
                <div className="filter-item">
                    <label htmlFor="" className="filter-label">研究产品类型</label>
                    {/* <Select
                        placeholder="请选择"
                        style={{ width: 130 }}
                        allowClear={true}
                        value={params.investigationMedicineType}
                        onChange={value => this.handleChange(value, 'investigationMedicineType')}
                    >
                        {medicineTypeOptions}
                    </Select> */}
                    <Cascader
                        allowClear={true}
                        style={{ width: 130 }}
                        placeholder="请选择"
                        options={MedicineTypeList}
                        value={params.investigationMedicineType}
                        onChange={value => this.handleChange(value, 'investigationMedicineType')}
                    />
                </div>
                {
                    !isPieChart &&
                    <div className="filter-item">
                        <label htmlFor="" className="filter-label">领域leader</label>
                        <SearchRetrieve
                            keyword='leaderName'
                            style={{ width: 140 }}
                            placeholder="输入姓名/工号检索"
                            value={params.leaderUserName}
                            params={{ limit: 20, status: 'ALL' }}
                            url={API_URL.user.queryLeaderList}
                            config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                            onChange={value => this.handleChange(value, 'leaderUser')}
                        />
                    </div>
                }
                
                <div className="filter-item">
                    <label className="filter-label">统计时间</label>
                    {
                        isPieChart ?
                            <MonthPicker
                                format={monthFormat}
                                allowClear={false}
                                disabledDate={this.disabledDate}
                                value={format('toMoment', params.statisticDate)}
                                onChange={(date, dateString) => this.handleChange(dateString, 'statisticDate')}
                                style={{width: 100, verticalAlign: 'middle'}}
                            />
                        :
                            <Select
                                placeholder="请选择"
                                value={format('toString', params.statisticDate)}
                                style={{ width: 100, verticalAlign: 'middle' }}
                                onChange={value => this.handleChange(value, 'statisticDate')}
                            >
                                {statisticsDateOption}
                            </Select>
                    }
                </div>
                <div className="filter-item" >
                    <Button type="primary" onClick={onSearch}>统计</Button>
                    { !isPieChart && <Button className="btn-yellow" style={{ marginLeft: 10 }} onClick={onExport}>明细导出</Button> }
                </div>
            </div>
        );
    }
}

export default ChartFilter;



// WEBPACK FOOTER //
// ./src/components/homePage/projectIndicatorAnalysis/components/ChartFilter.js